export const applyTheme = (theme: 'dark' | 'light') => {
  if (theme === 'light') {
    // TODO: need to remove dom usage
    document.body?.classList.add('v-theme--light');
    document.body?.classList.remove('v-theme--dark');
  } else {
    document.body?.classList.add('v-theme--dark');
    document.body?.classList.remove('v-theme--light');
  }
};

export const initTheme = () => {
  if (localStorage.getItem('SS-Portal-theme') === 'dark') {
    applyTheme('dark');
  } else {
    applyTheme('light');
  }
};
